import { remove } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";

interface DeleteBillingSpecialistParams {
  workplaceId: string;
}

const deleteBillingSpecialistResponseSchema = z.object({
  billingSpecialist: z.null(),
  userId: z.string(),
});

type DeleteBillingSpecialistResponse = z.infer<typeof deleteBillingSpecialistResponseSchema>;

export function useDeleteBillingSpecialist(
  options: UseMutationOptions<
    DeleteBillingSpecialistResponse,
    unknown,
    DeleteBillingSpecialistParams
  > = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId }) => {
      const response = await remove({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/billingSpecialist/${workplaceId}`,
        responseSchema: deleteBillingSpecialistResponseSchema,
      });
      return response.data;
    },
    ...options,
  });
}
